// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2yRHX","col":"Table_col__f5agr","fulfillmentStatus":"Table_fulfillmentStatus__2_xIe","emailCol":"Table_emailCol__23Ow7"};